import React from "react";
import logo from "../../../static/tb_logo.png";
import { LogoWrapper, LogoImage, LogoTagline } from "./Logo.styled";

interface ILogo {
  /** Brand line rendered under the wordmark, e.g. "know your audience". */
  tagline?: string;
  /** Wordmark width. Defaults to the original 170px. */
  width?: string;
}

const Logo = ({ tagline, width }: ILogo) => {
  const onScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <LogoWrapper $width={width}>
      <LogoImage src={logo} alt="Tendbe" onClick={onScrollToTop} />
      {tagline && <LogoTagline>{tagline}</LogoTagline>}
    </LogoWrapper>
  );
};

export default Logo;
